import { commonActionDetail } from 'app/analytics/selectors';
import { actionDetail } from 'app/analytics/helpers';
import translations from 'app/features/localization/translations.json';
import { BOTTOM, PRODUCTS_LEFT } from 'app/analytics/constants/positions';
import {
  REGISTRATION_REQUESTED,
  REGISTRATION_FAILED,
  REGISTRATION_SELECTED,
  REGISTRATION_SUCCEEDED,
} from 'app/features/authentication/actions/actionTypes';

const registration = {
  [REGISTRATION_SELECTED]: (getState, { payload }) => ({
    type: 'track',
    name: 'Registration Selected',
    properties: actionDetail({
      position: PRODUCTS_LEFT,
      textOfButtonOrLink: translations.buttons_create_my_account,
      ...commonActionDetail(getState()),
      ...payload,
    }),
  }),
  [REGISTRATION_REQUESTED]: (getState, { payload }) => ({
    type: 'track',
    name: 'Registration Requested',
    properties: {
      ...actionDetail({
        position: BOTTOM,
        textOfButtonOrLink: translations.buttons_create_my_account,
        ...commonActionDetail(getState()),
      }),
      ...payload,
    },
  }),
  [REGISTRATION_SUCCEEDED]: (_, { payload }) => ({
    type: 'track',
    name: 'Registration Succeeded',
    properties: payload,
  }),
  [REGISTRATION_FAILED]: (_, { payload }) => ({
    type: 'track',
    name: 'Registration Failed',
    properties: payload,
  }),
};

export default registration;
